<template lang="pug">
    div.static-loader-control
        svg-icon(iconId='static-loader')
</template>

<script>
export default {
    name: 'static-loader-control',
}
</script>
